<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.333 29.333">
    <path d="M25.896 0H3.437A3.44 3.44 0 000 3.437v22.459a3.44 3.44 0 003.437 3.437h22.459a3.44 3.44 0 003.437-3.437V3.437A3.44 3.44 0 0025.896 0zm1.145 25.896c0 .632-.513 1.145-1.145 1.145h-6.76v-8.364h3.668l.427-3.552h-4.095v-3.838c0-.98.739-1.719 1.719-1.719h2.577V6.245c-.679-.096-1.987-.229-2.577-.229-1.338 0-2.676.564-3.675 1.547-1.03 1.012-1.596 2.338-1.596 3.733v3.83H11.86v3.551h3.724v8.364H3.437a1.146 1.146 0 01-1.145-1.145V3.437c0-.632.513-1.145 1.145-1.145h22.459c.632 0 1.145.513 1.145 1.145z"/>
    </svg>
</template>

<script>
export default {

}
</script>
